<template>
  <div>
    <canvas :id="id"></canvas>
  </div>
</template>

<script>
import axios from "axios";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register the plugin correctly for Chart.js v2
Chart.plugins.register(ChartDataLabels);

export default {
  name: "school-chart",
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: "canvas"
    },
    type: {
      type: String,
      default: "pie" // Default to pie chart
    },
    legend: {
      type: Boolean,
      default: true // Default to pie chart
    },
    query: {
      type: String,
      default: ""
    },
    search: {
      type: Object,
      default: () => {}
    },
    label: {
      type: Array,
      default: () => []
    },
    labelField: {
      type: String,
      default: null
    },
    indexField: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      chartInstance: null,
      chartData: [],
      chartLabel: [],
      chartColor: [],
      title: "",
    };
  },

  watch: {
    query() {
      this.getData();

    },
    search: {
      handler(newVal, oldVal) {
        this.getData();
      },
      deep: true
    },
    label(data) {
      this.chartLabel = [];
      this.chartColor = [];
      data.forEach(item => {
        this.chartLabel.push(item.label);
        this.chartColor.push(item.color);
      });
    }
  },

  created() {
    this.getData();
    //
  },

  methods: {
    async getData() {
      try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/chart/query?query=${this.query}`, this.search);
        this.initChart();
        this.chartData = [];
        this.chartLabel = [];
        if(response.listPeriod1.length === 0) {
          this.title = "Không có dữ liệu";
          return;
        }
        // response.listPeriod1.forEach(rs => {
        //   this.chartLabel.push(rs[this.labelField]);
        //   this.chartData.push(rs[this.indexField]);
        // });
        this.chartData1 = response.listPeriod1;
        this.chartData2 = response.listPeriod2;
        this.chartData3 = response.listPeriod3;

        this.maxValue = Math.max(...this.chartData1, ...this.chartData2, ...this.chartData3) * 1.25;
        //this.chartData = this.chartData;
        // this.chartData1 = [30, 23, 46]
        // this.chartData2 = [55, 26, 35]
        // this.chartData3 = [43, 31, 42]
        this.title = "Báo cáo dữ liệu tổng quan";
        this.createChart();
      } catch (error) {
        console.error("Error fetching chart data:", error);
      }
    },

    initChart() {
      this.chartLabel = [];
      this.chartColor = [];
      this.label.forEach(item => {
        this.chartLabel.push(item.label);
        this.chartColor.push(item.color);
      });
    },

    createChart() {
      const ctxmark = document.getElementById(this.id).getContext("2d");

      // Destroy old chart instance before creating a new one
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      this.chartInstance = new Chart(ctxmark, {
        type: this.type,
        data: {
          //this.chartLabel
          labels: ["Chương học", "Bài học", "Phân học"],
          datasets: [
            {
              label: "Lớp 3-4t       ",
              data: this.chartData1,
              backgroundColor: "#808AC3",
              barThickness: 20,
              maxBarThickness: 50,
              // minBarLength: 50,
            },
            {
              label: "Lớp 4-5t       ",
              data: this.chartData2,
              backgroundColor: "#4958A9",
              barThickness: 20,
              maxBarThickness: 30,
              // minBarLength: 50,
            },
            {
              label: "Lớp 5-6t       ",
              data: this.chartData3,
              backgroundColor: "#162778",
              barThickness: 20,
              maxBarThickness: 30,
              // minBarLength: 50,
            }
          ]
        },
        options: {
          scales: {
            x: {
              min: 0,
              categoryPercentage: 0.7, // ✅ Giảm nhóm cột xuống để tạo khoảng cách lớn hơn
              barPercentage: 0.1, // ✅ Điều chỉnh độ rộng cột
            },
            yAxes: [{
              ticks: {
                min: 0,
                max: this.maxValue,
              }
            }]
          },
          responsive: true,
          maintainAspectRatio: true,
          title: {
            display: true,
            text: this.title,
            fontSize: 24, // ✅ Correct for Chart.js v2
            fontWeight: 'bold', // Optional, some versions support this
            fontColor: "black"
          },
          legend: {
            display: this.legend
          },
          plugins: {
            datalabels: {
              anchor: "end",
              align: "top",
              color: "#000",
              font: {
                //weight: "bold",
                size: 9
              },
              formatter: (value) => value,
            },
          }
        }
      });
    }
  }
};
</script>
